import script from "./PositionForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PositionForm.vue?vue&type=script&lang=ts&setup=true"

import "./PositionForm.vue?vue&type=style&index=0&id=18aedc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18aedc32"]])

export default __exports__